import { TextQuestion } from "@cur8/questionnaire";
import { Trans } from "./trans";

export const OtherHealthConditions = new TextQuestion(
  <Trans.OtherHealthConditions.Question />
);
